var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencilLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7924 0.947228C11.9876 0.751966 12.3042 0.751966 12.4995 0.947227L15.3279 3.77565C15.4217 3.86942 15.4744 3.99659 15.4744 4.1292C15.4744 4.26181 15.4217 4.38899 15.3279 4.48275L4.95701 14.8537C4.86324 14.9474 4.73606 15.0001 4.60344 15.0001L1.7751 15C1.49897 15 1.27512 14.7762 1.27511 14.5001L1.27502 11.6717C1.27502 11.5391 1.3277 11.4119 1.42147 11.3181L11.7924 0.947228ZM12.1459 2.00789L2.27503 11.8788L2.2751 14L4.39635 14.0001L14.2672 4.1292L12.1459 2.00789Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96379 3.7756C9.15905 3.58033 9.47563 3.58033 9.6709 3.7756L12.4993 6.60403C12.6946 6.79929 12.6946 7.11588 12.4993 7.31114C12.3041 7.5064 11.9875 7.5064 11.7922 7.31114L8.96379 4.4827C8.76853 4.28744 8.76853 3.97086 8.96379 3.7756Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilLarge);
export default __webpack_public_path__ + "static/media/edit-pencil-large.e2bca57d.svg";
export { ForwardRef as ReactComponent };